import { Text } from '@chakra-ui/core';
import { Td, Tr } from '@chakra-ui/table';
import React from 'react';

interface TableNoDataProps {
  columnCount: number;
  noDataText: string;
}

export function TableNoData({ columnCount, noDataText }: TableNoDataProps): JSX.Element {
  return (
    <Tr>
      <Td colSpan={columnCount} textAlign="center" py={5}>
        <Text data-testid="no-data-available">{noDataText}</Text>
      </Td>
    </Tr>
  );
}
